import { forwardRef, Fragment, memo } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./SearchEngineStepLabel.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const SearchEngineStepLabel = forwardRef(
	({ isComplete, className, defaultLabel, label, onClick }, ref) => {
		return (
			<>
				<div
					ref={ref}
					onClick={onClick}
					className={classNames("search-engine-step-label", className)}
				>
					{isComplete ? (
						<Fragment>
							<Typography
								variant={TYPOGRAPHY_VARIANTS.LARGE}
								isBold
								className="search-engine-step-label__label"
							>
								{label}
							</Typography>
							<div className="search-engine-step-label__edit">
								<FormattedMessage id="search.engine.edit.label" />
							</div>
						</Fragment>
					) : (
						<Typography
							variant={TYPOGRAPHY_VARIANTS.LARGE}
							isBold
							className="search-engine-step-label__label"
						>
							{defaultLabel}
						</Typography>
					)}
				</div>
			</>
		);
	}
);

SearchEngineStepLabel.displayName = "SearchEngineStepLabel";

SearchEngineStepLabel.propTypes = {
	isComplete: PropTypes.bool,
	defaultLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	className: PropTypes.string,
	onClick: PropTypes.func,
};

export default memo(SearchEngineStepLabel);
